import { LicenseColDefs } from './license-col-defs';

// Column definitions for grid of waitlisted APNs being managed by Rentalscape
export class StrWaitlistColDefs extends LicenseColDefs {
  licenseStatusColumn = {
    ...this.licenseStatusColumn,
    flex: 1,
  };

  waitlistPositionColumn = this.numberColumn({
    headerName: 'Position',
    field: 'waitlistPosition',
    minWidth: 200,
    maxWidth: 200,
    flex: 1,
  });

  licenseApplicationDateColumn = this.dateColumn({
    headerName: 'Application Date',
    field: 'applicationDate',
    minWidth: 200,
    maxWidth: 200,
    flex: 1,
  });

  licenseApplicationNumberColumn = this.textColumn({
    headerName: 'Application Number',
    field: 'applicationNumber',
    minWidth: 200,
    maxWidth: 200,
    flex: 1,
  });

  propertyAddressColumn = {
    ...this.addressColumn,
    headerName: 'Property Address',
    flex: 3,
  };

  registeredWaitlistEmailColumn = this.textColumn({
    headerName: 'Email Address',
    field: 'email',
    flex: 2,
  });

  invitationDateColumn = this.textColumn({
    headerName: 'Invitation Date',
    field: 'invitationDate',
    minWidth: 200,
    maxWidth: 200,
    flex: 1,
  });

  /**
   * Groups of columns for Pending
   *
   * @override
   */
  columnGroups() {
    return [
      this.waitlistPositionColumn,
      this.licenseApplicationDateColumn,
      this.licenseStatusColumn,
      this.licenseApplicationNumberColumn,
      this.propertyAddressColumn,
      this.registeredWaitlistEmailColumn,
      this.invitationDateColumn,
    ];
  }
}
